module.exports = __webpack_public_path__ + "static/media/icon-cross-white.9980bf93.svg";